module.exports = __webpack_public_path__ + "a4db87fe692cdaa6b40c1f821435378d.svg";